import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"max-height":"70vh","overflow":"hidden"} }

import CoreUiChatHistoryMessageContent from "~/core-ui/vue/chat/CoreUiChatHistoryMessageContent.vue";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


const __default__ = {
    name: "BuddyListItemTextTooltip"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CoreUiChatHistoryMessageContent, {
      message: __props.userdata.lastMessage,
      bbcode: _unref(CoreUiChatHistoryHelper).isOneOfCrossOperatorsChat(__props.userdata)
    }, null, 8, ["message", "bbcode"])
  ]))
}
}

})